import BlogList from "./items/BlogList";
import useFetch from "./useFetch";
import PendingBlog from "./items/PendingBlog";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import seoImg from "../img/seo.png";
import config from "./firebase/Config";

const Projects = ({ isLogged }) => {
  const {
    data: projects,
    isPending: projPending,
    error: projError,
  } = useFetch(`${config.db_path}/projects`);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>GEOECO Projects | Our Environmental Solutions in Action</title>
        <meta
          name="description"
          content="Discover the various projects undertaken by GEOECO. From renewable energy installations to environmental compliance audits, see how we deliver sustainable solutions."
        />
        <meta
          name="keywords"
          content="environmental projects, renewable energy projects, environmental compliance, sustainable solutions, GIS mapping projects"
        />
        <meta name="author" content="GEOECO" />
        <meta
          property="og:title"
          content="GEOECO Projects - Our Environmental Solutions in Action"
        />
        <meta
          property="og:description"
          content="View GEOECO's project portfolio to learn about our environmental solutions and successful project implementations."
        />
        <meta property="og:url" content="https://geoeco.org/projects" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={seoImg} />
      </Helmet>
      <div className="relative mx-auto max-w-6xl px-4">
        {isLogged && (
          <Link
            to="/create"
            className="absolute right-0 top-3 rounded-full bg-blue-500 px-4 py-1.5 text-center text-white duration-300 hover:bg-blue-800 md:pt-1.5 md:hover:scale-105"
          >
            Create
          </Link>
        )}
        {projPending && <PendingBlog />}
        {projError && <div>Cannot Fetch data from the resources</div>}
        {/* {error && <div>{error}</div>} */}

        {projects && (
          <BlogList
            blogs={Object.values(projects)}
            title={"Our Projects"}
            posttype={"project"}
          />
        )}
      </div>
    </>
  );
};

export default Projects;
